var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 10.3438L12.375 18.2188C11.9062 18.6406 11.2031 18.6406 10.7812 18.1719C10.3594 17.7031 10.3594 17 10.8281 16.5781L17.0625 10.625H1.125C0.46875 10.625 0 10.1562 0 9.5C0 8.89062 0.46875 8.375 1.125 8.375H17.0625L10.8281 2.46875C10.3594 2.04688 10.3594 1.29688 10.7812 0.875C11.2031 0.40625 11.9531 0.40625 12.375 0.828125L20.625 8.70312C20.8594 8.9375 21 9.21875 21 9.5C21 9.82812 20.8594 10.1094 20.625 10.3438Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMoreArrow);
export default __webpack_public_path__ + "static/media/learn-more-arrow.fb894094555d82eeb10c1340a71db973.svg";
export { ForwardRef as ReactComponent };